import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { ALL_BUTTONS } from "../ui_elements/ButtonGrid";

const services = ALL_BUTTONS.slice(0, -1);

const ServiceCatalog = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filtered = searchTerm
    ? services.filter(
        (btn) =>
          btn.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          btn.description.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : services;

  return (
    <div className="p-6 md:p-8 space-y-6 max-w-5xl mx-auto">

      {/* Search */}
      <div className="flex flex-col items-center gap-3 py-2">
        <p className="text-sm font-semibold uppercase tracking-widest text-blue-900">
          Encontre o que você precisa
        </p>
        <div className="relative w-full max-w-2xl">
          <MagnifyingGlassIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Pesquisar serviços..."
            className="w-full border border-gray-300 rounded-xl pl-12 pr-4 py-3 text-base text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>
      </div>

      {/* Grid */}
      {filtered.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((button, index) => (
            <a href={button.link} key={index}>
              <div
                className={`w-full h-36 rounded-2xl ${button.bg_color} flex flex-col items-center justify-center px-4 hover:opacity-90 transition`}
              >
                <div className={`text-5xl mb-2 ${button.color}`}>{button.icon}</div>
                <h5 className={`text-xl font-bold ${button.color} mb-1 text-center`}>{button.title}</h5>
                <span className={`text-sm font-medium text-center ${button.color}`}>{button.description}</span>
              </div>
            </a>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-center py-8">
          Nenhum serviço encontrado para "{searchTerm}".
        </p>
      )}

    </div>
  );
};

export default ServiceCatalog;
